module.exports = __webpack_public_path__ + "static/0134807f126d35c1ecc88fdeb1f68a4923df489a82a09e14881e184c80ab51b3-0abce5a405f9e490761025f779df2247.png";